"use client";

import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import React from "react";

import { cn } from "../../helpers";
import * as styles from "./radio-card.styled";

interface RadioCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  variant?: "default" | "compact";
}

export const CheckableRadioCard = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitive.Item>,
  RadioCardProps & { onClick?: () => void }
>(
  (
    {
      icon,
      label,
      value,
      checked,
      disabled,
      className,
      variant = "default",
      ...props
    },
    ref,
  ) => {
    const compact = variant === "compact";
    return (
      <label
        className={cn(
          styles.radioCardCheckableVariants({ checked, disabled }),
          compact && "min-h-[56px]",
          className,
        )}
        htmlFor={value}
      >
        <div className={cn(styles.root, "gap-4")}>
          <div className={cn(styles.wrapper, "min-w-0", compact && "gap-3")}>
            {icon}
            <span className={styles.labelPetinfo}>{label}</span>
            <RadioGroupPrimitive.Item
              className="sr-only"
              value={value}
              id={value}
              disabled={disabled}
              ref={ref}
              {...props}
            />
          </div>
          <div
            className={cn(
              styles.indicatorVariants({ checked, disabled }),
              compact && !checked && !disabled && "border-neutral-600",
            )}
            aria-selected={checked}
          >
            <div className={styles.indicator} />
          </div>
        </div>
      </label>
    );
  },
);
CheckableRadioCard.displayName = "CheckableRadioCard";
